import { DEFAULT_SITE } from './siteDefaults';

const IMPACT_KEYS = new Set([
  'farmers',
  'district',
  'distributors',
  'retailers',
  'projects',
  'contractFarmers',
  'export',
  'employees',
]);

const EMPTY_IMPACT_ROW = { value: '', label: '', icon: 'farmers' };

/** Hero bottom impact card — values from API with icon keys, fallback to defaults. */
export function resolveImpactStats(site) {
  const defaults = Array.isArray(DEFAULT_SITE.impactStats) ? DEFAULT_SITE.impactStats : [];
  const raw = site?.impactStats;
  if (!Array.isArray(raw) || raw.length === 0) {
    return defaults.length ? defaults.map((row) => ({ ...row })) : [];
  }
  return raw
    .filter((x) => x && typeof x === 'object')
    .map((s, i) => {
      const d = defaults[i] || defaults[0] || EMPTY_IMPACT_ROW;
      const icon = typeof s.icon === 'string' && IMPACT_KEYS.has(s.icon) ? s.icon : d.icon;
      return {
        value: typeof s.value === 'string' && s.value.trim() ? s.value.trim() : d.value,
        label: typeof s.label === 'string' && s.label.trim() ? s.label.trim() : d.label,
        icon,
      };
    });
}
